const { OWLS_FIVERR_CHOICE_EXPANSION, OWLS_CHOICE_PRICE_MODALITIES_AUTOMATION_EXP } = require('../experimentsEnum');
const { inExperiment } = require('..');
const { CHOICE_ALGO_A } = require('./constants');

const isInChoiceExpansionExp = (abTests) => inExperiment(OWLS_FIVERR_CHOICE_EXPANSION, abTests);
const isInModalitiesChoiceExpansionExp = (abTests) => inExperiment(OWLS_CHOICE_PRICE_MODALITIES_AUTOMATION_EXP, abTests);

const isChoiceEligible = (abTests, choiceEligibilities) => {
    if (isInModalitiesChoiceExpansionExp(abTests)) {
        return true;
    }

    if (!choiceEligibilities) {
        return false;
    }
    const formattedChoiceEligibilities = choiceEligibilities.map((choice) => choice.type);

    return formattedChoiceEligibilities.includes(CHOICE_ALGO_A);
};

module.exports = {
    isInChoiceExpansionExp,
    isInModalitiesChoiceExpansionExp,
    isChoiceEligible
};
